import { render, staticRenderFns } from "./ShareToClipboard.vue?vue&type=template&id=752b05f6&scoped=true&"
import script from "./ShareToClipboard.vue?vue&type=script&lang=js&"
export * from "./ShareToClipboard.vue?vue&type=script&lang=js&"
import style0 from "./ShareToClipboard.vue?vue&type=style&index=0&id=752b05f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752b05f6",
  null
  
)

export default component.exports